import React, { Fragment } from 'react';
import { Table, Button, Popup, Icon, Grid } from 'semantic-ui-react';
import SearchTableData from '../../util/SearchTableData';
import ReactExport from 'react-data-export';
import { getLeaseholderName } from '../util/util';
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

const formatDate = (date) => {
    if (!date) return '-';
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}.${month}.${year}.`;
};

const LeasesTable = ({
    allLeases,
    filteredLeases,
    activateEditRequest,
    writePrivilege,
    disabled,
    deletingRowId,
    deletingSaving,
    onDelete,
    onDeleteConfirm,
    onDeleteCancel,
    switchToDetails,
    getSortedLeases,
    fieldName,
    direction,
    excelData,
    getResults,
    handleSearchTextChange,
    leaseSearchFields
}) => (
    <Table celled selectable sortable>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell colSpan={writePrivilege ? 8 : 7}>
                    <Grid stackable verticalAlign="middle">
                        <Grid.Column width={14}>
                            <SearchTableData
                                profMozilla
                                data={allLeases}
                                getResults={getResults}
                                filterItem={leaseSearchFields}
                                onSearchTextChange={handleSearchTextChange}
                            />
                        </Grid.Column>
                        <Grid.Column width={2} textAlign="right">
                            <ExcelFile filename="Zakupi" element={<Popup
                                trigger={<Button animated="vertical" color="green" basic
                                                 floated="right" fluid
                                                 style={{ textAlign: 'center' }}>
                                    <Button.Content hidden><Icon name="download"/></Button.Content>
                                    <Button.Content visible>
                                        Excel
                                    </Button.Content>
                                </Button>}
                                content="Preuzmi Excel"
                                hideOnScroll
                                position="top center"
                            />}>
                                <ExcelSheet dataSet={sanitizeExcelDataSet(excelData)} name="Zakupi"/>
                            </ExcelFile>
                        </Grid.Column>
                    </Grid>
                </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                <Table.HeaderCell>Članica</Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'leaseholder' ? direction : null}
                    onClick={() => getSortedLeases('leaseholder', 'id')}
                >Zakupac</Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'leaseSubject' ? direction : null}
                    onClick={() => getSortedLeases('leaseSubject')}
                >Predmet zakupa</Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'dateStart' ? direction : null}
                    onClick={() => getSortedLeases('dateStart')}
                >Početak zakupa</Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'dateEnd' ? direction : null}
                    onClick={() => getSortedLeases('dateEnd')}
                >Istek zakupa</Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'incomePerMonth' ? direction : null}
                    onClick={() => getSortedLeases('incomePerMonth')}
                >Mjesečni prihodi (BAM)</Table.HeaderCell>
                {writePrivilege &&
                    <Table.HeaderCell></Table.HeaderCell>
                }
            </Table.Row>
        </Table.Header>
        <Table.Body>
            {filteredLeases.map((el, index) =>
                (
                    <Table.Row key={el.id}>
                        <Table.Cell width={1}>{index + 1}.</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{!!el.leaseholder && el.leaseholder.organizationalUnit.name}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{getLeaseholderName(el.leaseholder)}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{el.leaseSubject}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{formatDate(el.beginDate)}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{formatDate(el.endDate)}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{el.incomePerMonth}</Table.Cell>
                        {writePrivilege &&
                            <Table.Cell verticalAlign="middle" className="text-center">

                                {deletingRowId === el.id ? (
                                    <Fragment>
                                        <Popup content="Potvrdi" position="top center" trigger={
                                            <Button circular icon size="tiny" color="blue"
                                                    disabled={deletingSaving} loading={deletingSaving}
                                                    onClick={onDeleteConfirm}>
                                                <Icon name="check"/>
                                            </Button>
                                        }/>
                                        <Popup content="Otkaži" position="top center" trigger={
                                            <Button basic circular icon size="tiny" color="blue"
                                                    disabled={deletingSaving}
                                                    onClick={onDeleteCancel}>
                                                <Icon name="close"/>
                                            </Button>
                                        }/>
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        <Popup
                                            content="Izmjena"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    icon="pencil"
                                                    size="tiny"
                                                    color="green"
                                                    disabled={disabled || !!deletingRowId}
                                                    onClick={() => activateEditRequest(el)}
                                                />
                                            }
                                        />
                                        <Popup content="Brisanje" position="top center" trigger={
                                            <Button basic="true" circular icon="trash alternate" size="tiny" color="red"
                                                    disabled={disabled || !!deletingRowId}
                                                    onClick={() => onDelete(el.id)}/>
                                        }/>
                                    </Fragment>
                                )}
                            </Table.Cell>
                        }
                    </Table.Row>
                ))
            }
        </Table.Body>
    </Table>);

export default LeasesTable;



// WEBPACK FOOTER //
// ./src/views/Assets/Leases/LeasesTable.js